export default __webpack_public_path__ + "static/couple-778ae829dee9a4ded2d0771fa28a05f0.png";